// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jp-0";
export var fileCarousel = "_jp-2";
export var removeFileButton = "_jp-1";